<template>

    <a  class="client__block"
        :class="{ 'is-active': isActive && client.info, 'no-hover-client': !client.info }"
        role="button"
        @keydown="handleKeyPress"
        :tabindex="isVisible ? 0 : -1"
        data-gsap="fadeInRight"
        :data-gsap-delay="0.2 + index * 0.15"
        data-gsap-duration="0.6"
        data-gsap-distance="100"
                            >

        <div class="client__content">
            <div class="index__holder" >0{{index+1}}.</div>

            <SafeImage 
                :src="client.url" 
                :alt="client.alternativeText || client.name"
                :placeholder="PLACEHOLDER_IMAGES.CLIENT_LOGO"
                placeholderText="Client logo not available"
                imageClass="client-logo"
            />

            <div class="client__block__bottom">
                <h3> {{ client.name }} </h3>

                <!-- <p> {{ client.info }} </p> -->
                <span class="icon__info">
                    <info-icon/>
                </span>
            </div>
        </div>
        <div class="client__hover">
            <span class="client__text">
                {{client.info}}
            </span>
            <span class="icon__info client__close">
                <plus-icon/>
            </span>
        </div>

    </a>

</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed } from 'vue'
import SafeImage from "../../components/SafeImage.vue"
import { PLACEHOLDER_IMAGES } from "../../composables/useImageErrorHandler"

import PlusIcon from "../../components/svg/PlusIcon.vue"
import InfoIcon from "../../components/svg/InfoIcon.vue"

export default defineComponent({
    components:{
        PlusIcon,
        InfoIcon,
        SafeImage
    },
  props: {
    client: {
      type: Object as PropType<{ name: string; info: string; url: string; alternativeText: string }>,
      required: true
    },
    index: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: true
    }
  },

  setup(props, { emit } ) {
    const homeurl: string = import.meta.env.VITE_API_URL
    const { name, info, url, alternativeText } = props.client;


    function toggle (){
        emit('toggle', props.index)
    };

    function handleKeyPress(event: KeyboardEvent) {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        toggle();
      }
    }


    return {
      name,
      info,
      homeurl,
      url,
      alternativeText,
      toggle,
      handleKeyPress,
      PLACEHOLDER_IMAGES
    }
  }
})
</script>
